export default __webpack_public_path__ + "assets/radio-center.782d098e.svg";